export function sendForm(url,form,onreadystatechange){
    const formElement=form
    var formData = new FormData(formElement);
    var request = new XMLHttpRequest();
    request.open("POST", url);
    request.onreadystatechange=onreadystatechange;
    request.send(formData);
}